export default "__VITE_ASSET__8fbf6c4c__"